/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const OrderState = {
    Pending: 'pending',
    Confirmed: 'confirmed',
    Rejected: 'rejected',
    Cancelled: 'cancelled',
    Refunded: 'refunded',
    RefundPending: 'refund_pending',
    Send: 'send',
    ReadyForPickup: 'pickup',
    PickedUp: 'collected',
    WaitForIntegration: 'wait_for_integration',
    WaitForPayment: 'wait_for_payment',
    Delivered: 'delivered',
/**
     * @deprecated
     */    RefusedPickup: 'not_collected'
};
